import { Component, OnInit } from '@angular/core';
import { ConferenceService } from 'src/app/services/data/conference.service';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.css']
})
export class NotFoundComponent implements OnInit {

  constructor(private srv: ConferenceService) { }

  ngOnInit() {
  }

  onGetValues() { 
    this.srv.getValues().subscribe(
      data => console.log('success')
    );
}

}
